// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2945":"cffbced9","4150":"721f487b","4285":"b7a20745","9362":"56626323"}[chunkId] + ".chunk.css";
};